module.exports = __webpack_public_path__ + "static/img/044 6.2c93cf35.jpg";